$exso_sheets_login $mol_page
	title @ \Вход в систему
	head /
		<= Tools
	dirty? false
	required @ \Обязательно
	errors *
		invalid_credentials @ \Неверный логин или пароль
	login? null
	body /
		<= Form $mol_form
			form_fields /
				<= Title
				<= Name_field $mol_form_field
					name <= name_label @ \Логин
					bid <= name_bid \
					control <= Name_control $mol_string
						value? <=> name? \
				<= pass_field $mol_form_field
					name <= pass_label @ \Пароль
					bid <= pass_bid \
					control <= Pass_control $mol_password
						value? <=> pass? \
			buttons /
				<= Submit $mol_button_major
					title <= submit_label @ \Войти
					event_click <= event_submit null
